/** §4.2 / G3-7: emissive only on active paths and endpoint spheres. */

export const GEAR_METAL_EMISSIVE = 0x000000;
export const GEAR_METAL_EMISSIVE_INTENSITY = 0;

export const GEAR_PATH_EMISSIVE_ACTIVE = 0.35;
export const GEAR_PATH_EMISSIVE_IDLE = 0;

export const GEAR_ENDPOINT_EMISSIVE_ACTIVE = 0.65;
export const GEAR_ENDPOINT_EMISSIVE_IDLE = 0.38;

export function gearPathEmissiveIntensity(isActive: boolean): number {
  return isActive ? GEAR_PATH_EMISSIVE_ACTIVE : GEAR_PATH_EMISSIVE_IDLE;
}

export function gearEndpointEmissiveIntensity(isActive: boolean): number {
  return isActive ? GEAR_ENDPOINT_EMISSIVE_ACTIVE : GEAR_ENDPOINT_EMISSIVE_IDLE;
}

export function gearMetalMaterialEmissive(): {
  emissive: number;
  emissiveIntensity: number;
} {
  return {
    emissive: GEAR_METAL_EMISSIVE,
    emissiveIntensity: GEAR_METAL_EMISSIVE_INTENSITY,
  };
}
